import {boardOptions, colorsOptions, dimensionsOptions, typeOptions} from "../variables";
import {colorsNames, dimensionsNames} from "./enums";

export const isDimensionValid = (dimensionToCheck, dimensions) => {
    return dimensions[dimensionToCheck.key] >= dimensionToCheck.minValue
        && dimensions[dimensionToCheck.key] <= dimensionToCheck.maxValue
}

export const isHigh = (dimensions) => dimensions[dimensionsNames.HEIGHT] > 150

export const lowOrHighString = (dimensions) => {return isDimensionValid(dimensionsOptions.find(dimension => dimension.key === dimensionsNames.HEIGHT), dimensions)
    ? isHigh(dimensions) ? "_high" : "_low"
    : "_low"}

export const defaultPrice = (holderType, board) => {
    return parseInt(typeOptions.find(typeOption => typeOption.key === holderType).price)
        + parseInt(boardOptions.find(boardOption => boardOption.key === board).price)
}

export const formatPrice = (price) => {
    return price.toLocaleString('pl-PL', {style: 'currency', currency: 'PLN'})
}

//converting colors
const converter = require('ral-hex-converter')
const HEX_PALETTE = converter.hex.map((hex, index) => index !== 166 ? hex : "#C5C7C4") //there is an Error in the library
export const toRalWithoutError = (hex) => {
    if (hex === "") {
        return ""
    }
    if (hex === "#C5C7C4") {
        return "RAL7035"
    } else return converter.toRal(hex)
} //there is an Error in the library

export const toHexWithoutError = (ral) => {
    if (ral === "") {
        return ""
    }
    if (ral === "7035") {
        return "#C5C7C4"
    } else return converter.toHex(ral)
} //there is an Error in the library

const HEX_CODE = converter.toHex(5025) // 'RAL2013'  ('#C35831')

export const defaultOtherColorHex = toHexWithoutError(colorsOptions.find(color => color.key === colorsNames.OTHER).valueRal)

export const basicColors = colorsOptions.reduce((arr, color) => {
    if (color.key !== colorsNames.OTHER) {
        return [...arr, toHexWithoutError(color.valueRal)]
    }
    return arr
}, [])

export const HEX_PALETTE_WITHOUT_BASICS = HEX_PALETTE.filter(hex => !basicColors.includes(hex))